
import uiMixin from '@/mixins/uiMixin';

export default {
  mixins: [uiMixin],
  props: {
    blogs: {
      required: true,
      type: Array,
      default: () => [],
    },
    options: {
      required: false,
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultOptions: {
        cardCols: 9,
        itemsPerPage: 3,
      },
      isLoaded: false,
    };
  },
  methods: {
    toBlogsPage() {
      this.$router.push('/blog');
    },
  },
  computed: {
    mergedOptions() {
      return {
        ...this.defaultOptions,
        ...this.options,
      };
    },
  },
  watch: {
    blogs: {
      handler() {
        this.isLoaded = true;
      },
      immediate: true, // This ensures that the handler runs immediately when the component is created
    },
  },
};
